import * as z from "zod";

export const getAllShipViaCodes = {
  name: "getAllShipViaCodes" as const,
  input: z.object({}),
  output: z.object({
    shipViaCodes: z.array(
      z.object({ shipViaId: z.string(), shipViaCode: z.string() }),
    ),
  }),
};
